import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import IdentificationPage from './IdentificationPage.tsx';
import VerificationPage from './VerificationPage.tsx';
import CompaniesPage from './CompaniesPage.tsx';
import ChargesPage from './ChargesPage.tsx';
import SimulationPage from './SimulationPage.tsx';
import PaymentPage from './PaymentPage.tsx';
import TermPage from './TermPage.tsx';
import SuccessPage from './SuccessPage.tsx';
import PromoBanner from './PromoBanner.tsx';
import StepProgress from './StepProgress.tsx';

const DealApp: React.FC = () => {
  return (
    <HashRouter>
      <div className="min-h-screen w-full px-4 py-6 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-5xl">
          {/* Fora do <Routes>: e' uma tarja unica para todas as telas, e nao um pedaco
              repetido em cada pagina — repetido, uma tela esquecida fica sem ele. */}
          {/* <PromoBanner /> */}
          {/* Pelo mesmo motivo do banner: um lugar só, e a etapa sai da rota. */}
          <StepProgress />
          <Routes>
            <Route path="/" element={<Navigate to="/identification" replace />} />
            <Route path="/identification" element={<IdentificationPage />} />
            <Route path="/verification" element={<VerificationPage />} />
            <Route path="/companies" element={<CompaniesPage />} />
            <Route path="/charges/:companyId" element={<ChargesPage />} />
            <Route path="/agreement/:code/simulation" element={<SimulationPage />} />
            <Route path="/agreement/:code/term" element={<TermPage />} />
            <Route path="/agreement/:code/payment" element={<PaymentPage />} />
            <Route path="/agreement/:code/success" element={<SuccessPage />} />
            <Route path="*" element={<Navigate to="/identification" replace />} />
          </Routes>
        </div>
      </div>
    </HashRouter>
  );
};

export default DealApp;
